import React, { Component } from 'react';
import { Button, Modal } from 'carbon-components-react';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { Card } from '../../../../components';
import { listaCamisetas, listaAgasalhos } from '../../../../redux/data/fluxoUniformesTrade';
import { insertDmService, getDmService } from '../../../../services/Api';
import ConfirmRequestUniform from './ConfirmRequestUniform';

class RequestUniform extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openSize: false,
      screenConfirm: false,
      selectedItemShirt: null,
      selectedItemCoat: null,
      modalConfirm: false,
      numberRequest: null,
      selectedUnit: null,
      selectedStore: null,
      stores: [],
    };
  }

  selectedItemCoat = obj => {
    this.setState({
      selectedItemCoat: obj,
      sizeItemCoat: obj ? obj.label : null,
    });
  };

  selecetedItemIs = item => {
    const { selectedItemCoat, selectedItemShirt } = this.state;
    if (item === 'Camisetas') {
      return selectedItemShirt;
    }
    return selectedItemCoat;
  };

  confirmation = confirm => {
    this.setState({
      screenConfirm: !confirm,
    });
  };

  openModal = () => {
    this.setState({ modalConfirm: true });
  };

  closeModal = () => {
    this.setState({ modalConfirm: false });
    this.returnSearchTrades();
  };

  returnSearchTrades = () => {
    window.location.href = '/trade/uniformes';
  };

  loadStores = async unitId => {
    const { cleark } = this.props;
    try {
      const data = await getDmService(`/Atendente/GetLojas/${cleark.id}?idUnidade=${unitId}`);
      const arrStores = [];
      data.forEach(item => {
        arrStores.push({
          id: item.id,
          label: item.nome,
        });
      });

      this.setState({
        stores: arrStores,
      });
    } catch (error) {
      console.error(error);
    }
  };

  onChangeUnit = obj => {
    this.setState({
      selectedUnit: obj,
      selectedStore: null,
      // error: null,
    });

    if (obj) {
      this.loadStores(obj.id);
    }
  };

  onChangeStore = obj => {
    this.setState({
      selectedStore: obj,
      // error: null,
    });
  };

  postUniform() {
    const { sizeItemShirt, sizeItemCoat, selectedUnit, selectedStore } = this.state;
    if (selectedUnit && selectedStore) {
      const { cleark } = this.props;
      const urlEdit = '/Pedido/GeraPedidoMaterial';
      const formData = {
        TipoCadastro: { id: 4 },
        TipoAssistente: { id: 1 },
        Atendente: { id: cleark.id },
        Unidade: { Id: selectedUnit.id },
        Loja: { Id: selectedStore.id },
        TamanhoCamiseta: sizeItemShirt,
        TamanhoCamiseta2: sizeItemShirt,
        tamanhoCamiseta3: sizeItemShirt,
        TamanhoAgasalho: sizeItemCoat,
      };

      insertDmService(urlEdit, formData)
        .then(res => {
          this.setState({ numberRequest: res });
          this.openModal();
        })
        .catch(err => {
          toast.warn('Um erro inesperado ocorreu. Tente novamente mais tarde.');
          console.log(err);
        });
    } else {
      toast.warn('Você precisa selecionar unidade e loja');
    }
  }

  validatForm() {
    const { selectedItemShirt, selectedItemCoat, screenConfirm } = this.state;

    if (!selectedItemShirt || !selectedItemCoat) {
      toast.warn('A informação dos tamanhos para camisetas e agasalho é obrigatório.');
    } else {
      this.confirmation(screenConfirm);
    }
  }

  closeSize() {
    this.setState({
      openSize: false,
    });
  }

  showSize() {
    this.setState({
      openSize: true,
    });
  }

  selectedItemShirt(obj) {
    this.setState({
      selectedItemShirt: obj,
      sizeItemShirt: obj ? obj.label : null,
    });
  }

  render() {
    const {
      screenConfirm,
      modalConfirm,
      sizeItemShirt,
      sizeItemCoat,
      openSize,
      selectedItemShirt,
      selectedItemCoat,
      stores,
      selectedUnit,
      selectedStore,
      numberRequest,
    } = this.state;
    const { cleark, returnSearch } = this.props;

    return (
      <div>
        <Card className="center-box box-padd">
          {!screenConfirm ? (
            <div>
              <div className="bx--row">
                <div className="bx--col-xs-8">
                  <p className="description-option-title ">Solicitar Kit</p>
                  <p className="description-option-desc">Selecione o tamanho para a(s) peça(s).</p>
                </div>
                <div className="bx--col-xs-4">
                  <a onClick={() => this.showSize()} className="link-dm pointer f-right">
                    Ver Modelos
                  </a>
                </div>
                <div className="bx--col-xs-12">
                  <div className="mg-top-20">
                    <div className="bx--row mg-top-10">
                      <div className="bx--col-xs-12 bx--col-md-2">Camisetas</div>
                      <div className="bx--col-xs-12 bx--col-md-7">
                        <Select
                          value={selectedItemShirt}
                          className="select-dm search-dm"
                          label="Camisetas."
                          placeholder="Selecione o tamanho"
                          options={listaCamisetas}
                          onChange={e => this.selectedItemShirt(e)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mg-top-20">
                    <div className="bx--row mg-top-10">
                      <div className="bx--col-xs-12 bx--col-md-2">Agasalho</div>
                      <div className="bx--col-xs-12 bx--col-md-7">
                        <Select
                          value={selectedItemCoat}
                          className="select-dm search-dm"
                          label="Uniformes."
                          placeholder="Selecione o tamanho"
                          options={listaAgasalhos}
                          onChange={e => this.selectedItemCoat(e)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bx--row">
                <div className="bx--col-xs-12 v-md-margin buttons-footer-requests">
                  <Button onClick={() => this.validatForm()}> Avançar </Button>
                  <Button onClick={returnSearch} kind="ghost" className="h-sm-margin">
                    Voltar
                  </Button>
                </div>
              </div>
            </div>
          ) : (
            <div>
              <ConfirmRequestUniform
                coat={sizeItemCoat}
                shirt={sizeItemShirt}
                onChangeUnit={this.onChangeUnit}
                onChangeStore={this.onChangeStore}
                selectedUnit={selectedUnit}
                selectedStore={selectedStore}
                stores={stores}
                cleark={cleark}
              />
              <div className="bx--row">
                <div className="bx--col-xs-12 v-md-margin buttons-footer-requests">
                  <Button onClick={() => this.postUniform()}> Confirmar </Button>
                  <Button
                    onClick={() => this.confirmation(screenConfirm)}
                    kind="ghost"
                    className="h-sm-margin"
                  >
                      Voltar
                  </Button>
                </div>
              </div>
            </div>
            )}
        </Card>
        <div>
          <Modal
            onRequestClose={() => this.closeModal()}
            onRequestSubmit={() => this.closeModal()}
            iconDescription="Fechar"
            className="some-class confirm-trade"
            open={modalConfirm}
            modalHeading="Pedido feito com sucesso."
            primaryButtonText="Ok, Entendi"
            secondaryButtonText="aaa"
          >
            <div>
              <p>
                <strong>
                  {`Número do seu pedido ${numberRequest}.`}
                </strong>
              </p>
              <p className="finalizado-pedido">
                A qualquer momento você poderá acompanhá-lo clicando no ícone
                {' '}
                <a className="notifications pointer" href="/pedidos">
                  <i className="assignment" />
                </a>
                {' '}
                <br />
                disponível no canto superior da sua tela.
              </p>
              <p className="finalizado-pedido">Prazo de entrega: 5 dias úteis</p>
            </div>
          </Modal>

          <Modal
            onRequestClose={() => this.closeSize()}
            onRequestSubmit={() => this.closeSize()}
            iconDescription="Fechar"
            className="some-class confirm-trade"
            open={openSize}
            modalHeading="Medidas"
            primaryButtonText="Ok, Entendi"
            secondaryButtonText="aaa"
          >
            <div className="warning-modal-txt">
              <img
                className="img-responsive"
                src={require('./../../../../assets/images/sizesshirt.jpg')}
                alt=""
              />

            </div>
          </Modal>
        </div>
      </div>
    );
  }
}

export default RequestUniform;



// WEBPACK FOOTER //
// ./src/screens/client/trades/uniforms/RequestUniform.jsx